import * as React from 'react';
import styled from 'styled-components';
import { color, space } from '@core-ds/primitives';

const Container = styled.a`
   display: flex;
   align-items: center;
   padding: 8px ${space[4]};
   font-weight: normal;
   font-size: 14px;
   color: ${color.gray8};

   :hover {
      background: ${color.gray1};
      text-decoration: none;
   }
`;

const Text = styled.h3`
   flex: 1;
   margin: 0;
   font-size: 14px;
   font-weight: normal;
   color: ${color.gray8};
`;

const Badge = styled.h3`
   margin: 0;
   font-size: 14px;
   font-weight: normal;
   color: ${color.blue};
   text-align: right;
`;

const MenuButton = ({ id, onClick, className, text, badge, url }) => {
   return (
      <Container onClick={onClick} className={className} href={url}>
         <Text id={id}>{text}</Text>
         {badge && <Badge>{badge}</Badge>}
      </Container>
   );
};

export default MenuButton;
